/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : ionic 5 foodies app
  Created : 28-Feb-2021
  This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2020-present initappz.
*/
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'https://quiuboapi.inrocar.com/index.php/',
  mediaURL: 'https://quiuboapi.inrocar.com/uploads/',
  onesignal: {
    appId: '45fe6d85-3a36-40f0-9f49-ac5e7b82b712',
    googleProjectNumber: '330746975962',
    restKey: 'NmQ4MmVkYjQtNDM0Yi00ZTU2LTliM2EtMTM0MTUxNWZlYzI1'
  },
  general: {
    symbol: '$',
    code: 'USD'
  },
  authToken: 'quiubo$2021',
  default_country_code: '503'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
